import {
  EMPTY_FUNCTION,
  EMPTY_FUNCTION_ASYNC,
} from '../../../../constants/common'
import { UserProfileContextProvider } from '../../../User'
import { UserProfilePageActionsWidget } from '../../../UserProfilePage'
import { Container } from '../../Container'

import { PROFILE_ACTIONS_WIDGET_USER_STAFF_VARIANTS } from './ProfileActionsWidgetUserStaff.constants'

function ProfileActionsWidgetUserStaff() {
  return PROFILE_ACTIONS_WIDGET_USER_STAFF_VARIANTS.map(
    ({ label, staffData }) => (
      <Container key={label} label={label}>
        <UserProfileContextProvider
          isInitiated
          handleCloseModal={EMPTY_FUNCTION}
          handleEntityReload={EMPTY_FUNCTION_ASYNC}
          handleReloadTabs={EMPTY_FUNCTION_ASYNC}
          handleUpdateEntity={EMPTY_FUNCTION_ASYNC}
          isLoading={false}
          isPerformingAction={false}
          setModal={EMPTY_FUNCTION}
          setPerformingAction={EMPTY_FUNCTION}
          userData={staffData}
        >
          <UserProfilePageActionsWidget />
        </UserProfileContextProvider>
      </Container>
    )
  )
}

export default ProfileActionsWidgetUserStaff
